<template>
  <div class="aside" :style="ismobile?'width:270px':'width:50px'">
    <img v-if=ismobile src= "../../assets/images/morpheus_logo_b.png"
         @click="goFirst"
         class="logo cursor">
    <img v-else src= "../../assets/images/morpheusb.png"
          @click="goFirst"
          style="width: 60px; margin-top: 41px;
          margin-bottom: 11px;">
    <div class="menus"
         :class="{'en': lang == 'EN'}" >
      <div class="mlabel" @click="changeMenu('morpheus')" style="background: rgb(232, 236, 244);">
        <img v-if="type==='morpheus'" class="myimg" src="../../assets/images/Messaging.png">
        <img v-else class="myimg" src="../../assets/images/Messaging.png">
         <label v-if="ismobile" :class="{'active' : type === 'morpheus'}">
             <span class="sidespan">{{"Chat"}}</span></label>
      </div>
      <div class="mlabel"  @click="changeMenu('green-mining')">
        <img v-if="type==='green-mining'" class="myimg" src="../../assets/images/Layers.png">
        <img v-else class="myimg" src="../../assets/images/Layers.png">
        <label v-if="ismobile" :class="{'active' : type === 'green-mining'}">
             <span class="sidespan">{{"Docs"}}</span></label>
      </div>
      <div class="mlabel" @click="changeMenu('jointMining')">
        <img v-if="type==='jointMining'" class="myimg" src="../../assets/images/Settings.png">
        <img v-else class="myimg" src="../../assets/images/Settings.png">
        <label v-if="ismobile" :class="{'active' : type === 'jointMining'}">
             <span class="sidespan">{{"MANTA"}}</span></label>
      </div>
      <div class="mlabel" @click="changeMenu('ai-application')">
        <img v-if="type==='ai-application'" class="myimg" src="../../assets/images/Message.png">
        <img v-else class="myimg" src="../../assets/images/Message.png">
        <label v-if="ismobile" :class="{'active' : type === 'ai-application'}">
             <span class="sidespan">{{"Contact Us"}}</span></label>
      </div>
       <!-- <el-divider></el-divider> -->
      <div class="mlabel" @click="changeMenu('offlineSend')">
        <img v-if="type==='offlineSend'" class="myimg" src="../../assets/images/User.png">
        <img v-else class="myimg" src="../../assets/images/User.png">
         <label v-if="ismobile" :class="{'active' : type === 'offlineSend'}">
             <span class="sidespan">{{"Community"}}</span></label>
      </div>
      <div class="mlabel" @click="clickhelp()">
          <img v-if="type==='crossChain'" class="myimg" src="../../assets/images/Dashboard.png">
        <img v-else class="myimg" src="../../assets/images/Dashboard.png">
          <label v-if="ismobile" :class="{'active' : type === 'crossChain'}">
             <span class="sidespan">{{"Help"}}</span>
             </label>
      </div>
    </div>
    <div v-if="ismobile" class="botlogo">
          <img style="margin-top:130px;width:173px;height:68px" src="../../assets/images/logo.png">
    </div>
  </div>
</template>
<script>
import Bus from '@/assets/js/Bus'
import store from '@/store'
import * as storeLocal from 'store'

export default {
  name: 'Aside',
  data () {
    return {
      type: 'morpheus',
      lang: this.$i18n.locale,
      isUnlock: false,
      beforeUrl: '',
      userName: '',
      deposit: {},
      ismobile: false
    }
  },
  watch: {
  },
  mounted () {
    console.log(window)
    this.ismobile = !window.ismobile
    Bus.$on('changeLang', (data) => {
      this.lang = data
    })
    Bus.$on('openWallet', (data) => {
      if (data === 'close') {
        this.isUnlock = false
      } else {
        this.isUnlock = true
      }
    })
    try {
      let wallet = this.$store.state.wallet
      if (wallet != null) {
        let greetings = storeLocal.get('greetings')
        if (typeof (greetings) === 'string') {
          greetings = JSON.parse(greetings)
        }
        for (let i = 0, length = greetings.length; i < length; i++) {
          if (greetings[i].address === wallet.address) {
            this.userName = greetings.content
            break
          }
        }
      }
    } catch (error) {
    }
  },
  methods: {
    changeLang (lang) {
      if (lang !== this.lang) {
        Bus.$emit('changeLang', lang)
        storeLocal.set('lang', lang)
        this.lang = lang
        this.$i18n.locale = lang
      }
    },
    clickhelp (lang) {
      Bus.$emit('clickHelp', '')
    },
    changeMenu (status) {
      this.beforeUrl = status
      this.type = status
      if (status === 'green-mining') {
        window.open('https://docs.matrix.io', '_blank')
      } else if (status === 'morpheus') {
      } else if (status === 'ai-application') {
        window.open('mailto:EricChoy@Matrix.io?', '_blank')
      } else if (status === 'offlineSend') {
        window.open('https://www.matrix.io/index.php/community', '_blank')
      } else if (status === 'jointMining') {
        window.open('https://docs.matrix.io/manta', '_blank')
      } else if (status === 'crossChain') {
      } else {
        store.commit('UPDATE_BEFOREURL', '/' + status)
        this.$router.push({ path: '/' + status })
      }
    },
    goFirst () {
      this.$router.push({ path: '/morpheus/chat' }).catch(err => err)
    }
  }
}
</script>

<style scoped lang="less">
.aside {
  align-items: center;
  margin: auto;
  width: 270px;
  line-height:50px;
  background: #DDE1EC;
  .logo {
    height: 55px;
    // width: 181px;
    margin-top: 41px;
    margin-bottom: 11px;
  }
  .menus {
    margin-left: 0px ;
    .mlabel{
      height: 40px;
      margin-top:10px;
      padding-left: 20px;
      text-align: left;
      text-align: -webkit-left;
      text-align: -moz-left;
      label {
      display: inline-block;
      position: absolute;
      width: 150px;
      margin-top: 10px;
      color: rgb(0, 102, 255);
      color: #77838F;
      font-family: Open Sans;
      font-size: 18px;
      font-weight: 600;
      line-height: 22px;
      letter-spacing: 1px;
      text-align: left;
      cursor: pointer;
    }
    label:not(:first-child) {
      margin-left: 1rem;
    }
    .active {
      opacity: 1;
      // color: #0066FF;
      color: #77838F;
    }
    label:nth-child(3):after {
      margin-left: -34px;
    }
    label:nth-child(4):after {
      margin-left: -30px;
    }
    label:nth-child(5):after {
      margin-left: -22px;
    }
    }
  }
  .sidespan{
    width: 125px;
    display: inline-block;
    cursor: pointer;
  }
  .myimg{
    width: 20px;
    height: 20px;
    opacity: 0.9;
  }
  /deep/.el-dropdown-menu {
    position: absolute;
    left: 1100px;
    top: 44px;
    z-index: 2007;
  }
  .el-dropdown {
    line-height: 0 !important;
  }
  .botlogo{
    position: absolute;
    bottom: 20px;
    left: 60px
  }
  //  @media (max-width: 992px) {
  //  .botlogo {
  //   position: inherit;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Aside.vue